import { Permissions } from '../shared/constants/permissions';
import { Permission } from '../types/permissions';

export const filterPermissions = (permission: Permission, _isAdmin: boolean) => {
  // The 'whitelist' permission isn't displayed in the normal way
  return permission.key !== Permissions.Whitelist;
};

export default filterPermissions;
